import './navbar.css';
import 'react-toastify/dist/ReactToastify.css';
import { handleLogout } from './Login';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Logobianco from './logo_bianco.png';
import React, {  useEffect  } from 'react';

function Navbar() {

  const { t, i18n } = useTranslation();

  // Stato locale per il pulsante (inizializzato alla lingua corrente)
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'it');


  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  const toggleLanguage = () => {
    const newLang = lang === 'it' ? 'en' : 'it';
    setLang(newLang);
    localStorage.setItem('lang', newLang);

    i18n.changeLanguage(newLang).then(() => {
      if (newLang === 'en') alert("The English version is under development!");
    });
  };

  return (
    <div className="navbar">
      <div className="dropdown">
        <a href="/" className="logo-wrapper">
          <img src={Logobianco} alt="Company Logo" className="logo-navbar" />
        </a>
      </div>

      <div className="dropdown">
        <button className="dropbtn">{t('navbar.training')}
          <i className="fa fa-caret-down"></i>
        </button>
        <div className="dropdown-content">
          <a href="/#id2">{t('pages.home.tb')}</a>
          <a href="/#id3">{t('navbar.consulenza')}</a>
        </div>
      </div>

      <div className="dropdown">
        <button className="dropbtn">{t('navbar.personal_area')}
          <i className="fa fa-caret-down"></i>
        </button>
        <div className="dropdown-content">
          <a href="/ves_dashboard">{t('navbar.ves')}</a>
          <a href="\Login">{t('navbar.login')}</a>
          <a onClick={handleLogout}>{t('navbar.logout')}</a>
          <a href="\newuser">{t('navbar.register')}</a>
        </div>
      </div>

      <div className="dropdown">
        <button className="dropbtn">{t('navbar.open_lab')}
          <i className="fa fa-caret-down"></i>
        </button>
        <div className="dropdown-content">
          <a href="/Geoutilities">{t('navbar.geoutilities')}</a>
          <a href="/GeoData">{t('navbar.geodatabase')}</a>
        </div>
      </div>

      <div className="dropdown">
        <a href="\chisono">{t('navbar.code')}</a>
      </div>

      <div className="dropdown">
        <a href="\contatti">{t('navbar.contact')}</a>
      </div>

      {/* Toggle lingua */}
      <div className="dropdown lang-switcher">
        <button className={`flag-btn ${lang}`} onClick={toggleLanguage}>
          {lang.toUpperCase()}
        </button>
      </div>
     
    </div>
  );
}

export default Navbar;
